(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('TestDetailController', TestDetailController);

    TestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Test'];

    function TestDetailController($scope, $rootScope, $stateParams, previousState, entity, Test) {
        var vm = this;

        vm.test = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:testUpdate', function(event, result) {
            vm.test = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
